import qiniuStroage from './qiniu';
import upyunStroage from './upyun';
import Cookies from 'js-cookie';
import {getHomeworkInfo} from './homework-info';
import {
    addHomework,
    scratchFileStorageHost,
    scratchFileStorageUpYunHost,
    getViewWorkMobileHost
} from './service';

/*
*@param {string} homeworkType 作业类型，值为 PUBLISHED 或 DRAFT
*@param {blob} homeworkFile 作业内容
*@param {function} progressObserver 需要监听上传进度的方法，传入的参数为整形数字
*@return {Promise}
*/

const saveHomework = function (homeworkFile, homeworkType, upLoadLine, progressObserver){
    return new Promise((resolve, reject) => {

        const userId = Number(Cookies.get('userId'));
        if (!userId) {
            return;
        }
        if (!homeworkType) {
            return;
        }
        const date = new Date();
        const timestamp = date.getTime();
        const randomNum = parseInt(Math.random() * 1000, 10);
        const homeworkName = `${userId}-${timestamp}-${randomNum}.sb3`;
        let homeworkUrl = `${scratchFileStorageHost}`;

        const callbackOnUploadCompleted = function (fileName) {
            const homeworkInfo = getHomeworkInfo();
            const courseId = Number(homeworkInfo.courseId);
            const unitId = Number(homeworkInfo.unitId);
            const lessonId = Number(homeworkInfo.lessonId);
            const sectionId = Number(homeworkInfo.sectionId);
            const url = `//${homeworkUrl}/${fileName}`;
            const nickname = Cookies.get('nickname');
            addHomework(userId, nickname, sectionId, courseId, unitId, lessonId, url, homeworkType)
                .then(response => response.json())
                .then(json => {
                    if (json.errcode === 0) {
                        if (homeworkType === 'PUBLISHED') {
                            const viewWorkMobileHost = getViewWorkMobileHost();
                            const qrcodeUrl = `https://${viewWorkMobileHost}/homeworks/${json.data.id}`;
                            resolve({qrcodeUrl: qrcodeUrl});
                        } else if (homeworkType === 'DRAFT') {
                            resolve(json.data);
                        }
                    } else {
                        reject();
                    }
                })
                .catch(err => reject({err: err}));
        };
        switch (upLoadLine) {
        case 'qiniu':
            homeworkUrl = `${scratchFileStorageHost}`;
            qiniuStroage(homeworkName, homeworkFile, progressObserver, callbackOnUploadCompleted, reject);
            break;
        case 'upyun':
            homeworkUrl = `${scratchFileStorageUpYunHost}`;
            upyunStroage(homeworkName, homeworkFile, callbackOnUploadCompleted, reject);
            break;
        default:
            homeworkUrl = `${scratchFileStorageHost}`;
            qiniuStroage(homeworkName, homeworkFile, progressObserver, callbackOnUploadCompleted, reject);
        }
    });
};

export {
    saveHomework
};
